import FocalPointImage from "components/FocalPointImage";
import getContainContent from "selectors/breakpoint/getContainContent";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";

import { compose, fromRenderProps } from "recompose";
import { WithActiveChapterId } from "../context/ActiveChapterContext";

const getImageEntity = (state, { imageId }) =>
  state.story.entities.images[imageId];

function makeGetFocalPoint() {
  return createSelector(getImageEntity, (imageEntity) => ({
    focalX: imageEntity.focalX,
    focalY: imageEntity.focalY,
    height: imageEntity.height,
    width: imageEntity.width,
  }));
}

const makeMapStateToProps = () => {
  const getFocalPoint = makeGetFocalPoint();

  return (state, ownProps) => {
    const image = state.story.entities.images[ownProps.imageId];

    let contain = ownProps.contain;
    if (isNull(contain) || isUndefined(contain)) {
      contain = getContainContent(state, ownProps);
    }
    return {
      fitMode: contain ? "contain" : "cover",
      src: image.src,
      focalPoint: getFocalPoint(state, ownProps),
    };
  };
};

const ImageContainer = compose(
  // `activeChapterId` is needed by `getContaintContent`
  fromRenderProps(
    WithActiveChapterId,
    ({ activeChapterId }) => activeChapterId,
  ),
  connect(makeMapStateToProps),
)(FocalPointImage);

export default ImageContainer;
